import { render, staticRenderFns } from "./DeleteClassScore.vue?vue&type=template&id=0bc6e0fd&"
import script from "./DeleteClassScore.vue?vue&type=script&lang=js&"
export * from "./DeleteClassScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports